class AyumeMoodboard extends HTMLElement {
 connectedCallback(){if(this.cleanup)return;this.cleanup=this.setup();}
 disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
 setup(){
 const host=this,abort=new AbortController(),signal=abort.signal,observers=[],timers=new Set();
 const preference=matchMedia('(prefers-reduced-motion:reduce)');
 const on=(el,type,fn,options={})=>el.addEventListener(type,fn,{...options,signal});
 const later=(fn,ms)=>{const id=setTimeout(()=>{timers.delete(id);if(!signal.aborted)fn();},ms);timers.add(id);return id;};
  var reduce = preference.matches || document.querySelector('.av-header')?.dataset.avMotion === 'false';
  var canvas = host.querySelector('[data-mood-canvas]');
  var hint = null;
  var els = Array.prototype.slice.call(canvas.querySelectorAll('[data-fragment]'));
  var STIFF = 230, DAMP = 23;
  var W = 0, H = 0, topZ = els.length + 1, raf = 0, last = 0;
  var grid = false, introDone = false, drag = null, touch = null, suppressClick = 0;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function rng(seed) { return function () { seed |= 0; seed = seed + 0x6D2B79F5 | 0; var t = Math.imul(seed ^ seed >>> 15, 1 | seed); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }

  var S = els.map(function (el, i) {
    return { el: el, i: i, w: 0, h: 0, x: 0, y: 0, r: 0, s: 1, vx: 0, vy: 0, vr: 0, vs: 0, tx: 0, ty: 0, tr: 0, ts: 1, hx: 0, hy: 0, hr: 0, baseR: 0, mode: 'rest', free: el.classList.contains('free') };
  });
  var byEl = new Map(S.map(function (f) { return [f.el, f]; }));

  function measure() { var rc = canvas.getBoundingClientRect(); W = rc.width; H = rc.height; S.forEach(function (f) { f.w = f.el.offsetWidth; f.h = f.el.offsetHeight; }); }
  function bounds(f) { const insetX=Math.min(W/2, f.w*.58), insetY=Math.min(H/2, f.h*.58); return { minX: insetX, maxX: W-insetX, minY: insetY, maxY: H-insetY }; }
  function render(f) { f.el.style.transform = 'translate3d(' + (f.x - f.w / 2).toFixed(2) + 'px,' + (f.y - f.h / 2).toFixed(2) + 'px,0) rotate(' + f.r.toFixed(2) + 'deg) scale(' + f.s.toFixed(4) + ')'; }

  function layout() {
    var rnd = rng(1001);
    var n = S.length;
    var cols = Math.max(2, Math.round(Math.sqrt(n * W / H)));
    var rows = Math.ceil(n / cols);
    var cw = W / cols, ch = H / rows;
    var cells = [];
    for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) cells.push([c, r]);
    for (var i = cells.length - 1; i > 0; i--) { var j = Math.floor(rnd() * (i + 1)); var tmp = cells[i]; cells[i] = cells[j]; cells[j] = tmp; }
    S.forEach(function (f, k) {
      var cell = cells[k];
      var b = bounds(f);
      f.hx = clamp((cell[0] + .5) * cw + (rnd() - .5) * cw * .55, b.minX, b.maxX);
      f.hy = clamp((cell[1] + .5) * ch + (rnd() - .5) * ch * .55, b.minY, b.maxY);
      f.hr = (rnd() - .5) * 2 * (f.free ? 14 : 7);
    });
  }

  function spring(f, key, vkey, target, dt, k, d) {
    var a = k * (target - f[key]) - d * f[vkey];
    f[vkey] += a * dt; f[key] += f[vkey] * dt;
  }
  function settled(f) {
    return Math.abs(f.tx - f.x) < .08 && Math.abs(f.ty - f.y) < .08 && Math.abs(f.tr - f.r) < .02 && Math.abs(f.ts - f.s) < .0008 &&
      Math.abs(f.vx) < .08 && Math.abs(f.vy) < .08 && Math.abs(f.vr) < .05 && Math.abs(f.vs) < .002;
  }
  function step(f, dt) {
    if (f.mode === 'spring') {
      spring(f, 'x', 'vx', f.tx, dt, STIFF, DAMP); spring(f, 'y', 'vy', f.ty, dt, STIFF, DAMP);
      spring(f, 'r', 'vr', f.tr, dt, 170, 18); spring(f, 's', 'vs', f.ts, dt, 320, 26);
      if (settled(f)) { f.x = f.tx; f.y = f.ty; f.r = f.tr; f.s = f.ts; f.vx = f.vy = f.vr = f.vs = 0; f.mode = 'rest'; }
    } else if (f.mode === 'drag') {
      spring(f, 'r', 'vr', f.tr, dt, 260, 22); spring(f, 's', 'vs', f.ts, dt, 380, 26);
    } else if (f.mode === 'throw') {
      f.x += f.vx * dt; f.y += f.vy * dt;
      var fr = Math.pow(.0016, dt); f.vx *= fr; f.vy *= fr;
      var b = bounds(f);
      if (f.x < b.minX) { f.x = b.minX; f.vx = Math.abs(f.vx) * .35; } else if (f.x > b.maxX) { f.x = b.maxX; f.vx = -Math.abs(f.vx) * .35; }
      if (f.y < b.minY) { f.y = b.minY; f.vy = Math.abs(f.vy) * .35; } else if (f.y > b.maxY) { f.y = b.maxY; f.vy = -Math.abs(f.vy) * .35; }
      spring(f, 'r', 'vr', f.tr, dt, 170, 18); spring(f, 's', 'vs', f.ts, dt, 320, 26);
      if (Math.sqrt(f.vx * f.vx + f.vy * f.vy) < 14) { f.tx = f.x; f.ty = f.y; f.vx = f.vy = 0; f.mode = 'spring'; }
    }
    render(f);
  }
  function tick(now) {
    var dt = Math.min((now - last) / 1000, 1 / 30); last = now;
    var active = false;
    for (var i = 0; i < S.length; i++) { if (S[i].mode !== 'rest') { step(S[i], dt); active = true; } }
    raf = active && !grid && !document.hidden ? requestAnimationFrame(tick) : 0;
  }
  function kick() { if (!raf && !grid && !document.hidden) { last = performance.now(); raf = requestAnimationFrame(tick); } }

  function sendTo(f, x, y, r, s) {
    f.tx = x; f.ty = y; f.tr = r; f.ts = s;
    if (reduce) { f.x = x; f.y = y; f.r = r; f.s = s; f.mode = 'rest'; render(f); return; }
    f.mode = 'spring'; kick();
  }

  // Drag (mouse, pen, and touch after long press)
  function startDrag(f, cx, cy) {
    var rc = canvas.getBoundingClientRect();
    var now = performance.now();
    drag = { f: f, ox: cx - rc.left - f.x, oy: cy - rc.top - f.y, sx: cx, sy: cy, moved: false, startX: f.x, startY: f.y, samples: [{ x: cx, y: cy, t: now }] };
    f.mode = 'drag'; f.vx = f.vy = 0; f.ts = reduce ? 1 : 1.06; f.tr = f.baseR;
    f.el.style.zIndex = ++topZ;
    f.el.classList.add('lifted'); canvas.classList.add('dragging');
    kick();
  }
  function moveDrag(cx, cy) {
    if (!drag) return;
    var f = drag.f, rc = canvas.getBoundingClientRect(), b = bounds(f);
    if (!drag.moved && Math.abs(cx - drag.sx) + Math.abs(cy - drag.sy) > 6) drag.moved = true;
    f.x = clamp(cx - rc.left - drag.ox, b.minX - 30, b.maxX + 30);
    f.y = clamp(cy - rc.top - drag.oy, b.minY - 30, b.maxY + 30);
    var now = performance.now();
    drag.samples.push({ x: cx, y: cy, t: now });
    while (drag.samples.length > 6) drag.samples.shift();
    var s0 = drag.samples[0], dtp = Math.max((now - s0.t) / 1000, .016);
    var vx = (cx - s0.x) / dtp;
    f.tr = reduce ? f.baseR : f.baseR + clamp(vx * .011, -9, 9);
    if (reduce) render(f);
  }
  function endDrag(cancel) {
    if (!drag) return;
    var d = drag, f = d.f; drag = null;
    f.el.classList.remove('lifted'); canvas.classList.remove('dragging');
    if (d.moved) suppressClick = performance.now();
    if (cancel) { sendTo(f, d.startX, d.startY, f.baseR, 1); return; }
    var s0 = d.samples[0], s1 = d.samples[d.samples.length - 1];
    var dtp = Math.max((s1.t - s0.t) / 1000, .016);
    var vx = (s1.x - s0.x) / dtp, vy = (s1.y - s0.y) / dtp;
    if (performance.now() - s1.t > 90) { vx = 0; vy = 0; }
    var sp = Math.sqrt(vx * vx + vy * vy);
    if (sp > 2400) { vx *= 2400 / sp; vy *= 2400 / sp; }
    f.baseR = clamp(f.baseR + vx * .0025, -16, 16);
    f.tr = f.baseR; f.ts = 1;
    if (reduce || !d.moved) { sendTo(f, clamp(f.x, bounds(f).minX, bounds(f).maxX), clamp(f.y, bounds(f).minY, bounds(f).maxY), f.baseR, 1); return; }
    f.vx = vx; f.vy = vy; f.mode = 'throw'; kick();
  }

  S.forEach(function (f) {
    var el = f.el;
    on(el, 'pointerdown', function (e) {
      if (grid || e.pointerType === 'touch' || e.button !== 0) return;
      startDrag(f, e.clientX, e.clientY);
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    on(el, 'pointermove', function (e) { if (drag && drag.f === f && e.pointerType !== 'touch') moveDrag(e.clientX, e.clientY); });
    on(el, 'pointerup', function (e) { if (drag && drag.f === f && e.pointerType !== 'touch') endDrag(false); });
    on(el, 'pointercancel', function (e) { if (drag && drag.f === f && e.pointerType !== 'touch') endDrag(true); });
    on(el, 'pointerenter', function (e) { if (e.pointerType === 'mouse' && !drag && !grid && !reduce && f.mode !== 'throw') { f.ts = 1.025; if (f.mode === 'rest') { f.tx = f.x; f.ty = f.y; f.tr = f.r; f.mode = 'spring'; } kick(); } });
    on(el, 'pointerleave', function (e) { if (e.pointerType === 'mouse' && (!drag || drag.f !== f) && !grid && !reduce) { f.ts = 1; if (f.mode === 'rest') { f.tx = f.x; f.ty = f.y; f.tr = f.r; f.mode = 'spring'; } kick(); } });

    // Touch: long press lifts the fragment; a quick swipe keeps scrolling the page
    on(el, 'touchstart', function (e) {
      if (grid || e.touches.length > 1) return;
      var t = e.touches[0];
      touch = { f: f, sx: t.clientX, sy: t.clientY, cx: t.clientX, cy: t.clientY, lifted: false };
      touch.timer = later(function () {
        if (!touch || touch.f !== f) return;
        touch.lifted = true;
        startDrag(f, touch.cx, touch.cy);
        if (hint) hint.classList.add('gone');
      }, 260);
    }, { passive: true });
    on(el, 'touchmove', function (e) {
      if (!touch || touch.f !== f) return;
      var t = e.touches[0]; touch.cx = t.clientX; touch.cy = t.clientY;
      if (!touch.lifted) {
        if (Math.abs(t.clientX - touch.sx) + Math.abs(t.clientY - touch.sy) > 9) { clearTimeout(touch.timer); touch = null; }
        return;
      }
      e.preventDefault();
      moveDrag(t.clientX, t.clientY);
    }, { passive: false });
    on(el, 'touchend', function () {
      if (!touch || touch.f !== f) return;
      clearTimeout(touch.timer);
      if (touch.lifted) { suppressClick = performance.now(); endDrag(false); }
      touch = null;
    }, { passive: true });
    on(el, 'touchcancel', function () {
      if (!touch || touch.f !== f) return;
      clearTimeout(touch.timer);
      if (touch.lifted) endDrag(true);
      touch = null;
    }, { passive: true });
    on(el, 'contextmenu', function (e) { e.preventDefault(); });

    on(el, 'click', function () {
      if (performance.now() - suppressClick < 350) return;
      openLightbox(f);
    });
    on(el, 'keydown', function (e) {
      if (grid) return;
      var step = e.shiftKey ? 48 : 12, dx = 0, dy = 0;
      if (e.key === 'ArrowLeft') dx = -step; else if (e.key === 'ArrowRight') dx = step;
      else if (e.key === 'ArrowUp') dy = -step; else if (e.key === 'ArrowDown') dy = step; else return;
      e.preventDefault();
      var b = bounds(f);
      f.el.style.zIndex = ++topZ;
      sendTo(f, clamp((f.mode === 'rest' ? f.x : f.tx) + dx, b.minX, b.maxX), clamp((f.mode === 'rest' ? f.y : f.ty) + dy, b.minY, b.maxY), f.baseR, 1);
    });
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape' && drag) endDrag(true); });

  // Intro: the fragments start as a pile, then scatter when the section comes into view
  function pile() {
    var rnd = rng(77);
    S.forEach(function (f) {
      f.x = W / 2 + (rnd() - .5) * 40; f.y = H / 2 + (rnd() - .5) * 40; f.r = (rnd() - .5) * 36; f.s = .84; f.baseR = f.hr;
      render(f);
    });
  }
  function scatter() {
    introDone = true;
    S.forEach(function (f, i) {
      if (reduce) { sendTo(f, f.hx, f.hy, f.hr, 1); return; }
      later(function () { if (!grid) sendTo(f, f.hx, f.hy, f.hr, 1); }, 90 + i * 42);
    });
  }

  function init() {
    if(signal.aborted)return;
    measure(); layout();
    if (reduce) { S.forEach(function (f) { f.x = f.hx; f.y = f.hy; f.r = f.baseR = f.hr; f.s = 1; render(f); }); introDone = true; }
    else pile();
    S.forEach(function (f, i) { f.el.style.zIndex = i + 1; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        canvas.classList.toggle('offscreen', !en.isIntersecting);
        if (en.isIntersecting && en.intersectionRatio > .22 && !introDone) scatter();
      });
    }, { threshold: [0, .22, .5] });
    observers.push(io); io.observe(canvas);
  }

  var lastWidth = window.innerWidth;
  on(window, 'resize', function () {
    if (window.innerWidth === lastWidth || grid) return;
    lastWidth = window.innerWidth;
    var oW = W, oH = H;
    measure(); layout();
    S.forEach(function (f) {
      var b = bounds(f);
      f.x = clamp(f.x / oW * W, b.minX, b.maxX); f.y = clamp(f.y / oH * H, b.minY, b.maxY);
      f.tx = f.x; f.ty = f.y; render(f);
    });
  });

  // Reset
  on(host.querySelector('[data-mood-reset]'), 'click', function () {
    if (grid) toggleGrid();
    S.forEach(function (f, i) {
      f.baseR = f.hr; f.el.style.zIndex = i + 1;
      if (reduce) { sendTo(f, f.hx, f.hy, f.hr, 1); return; }
      later(function () { sendTo(f, f.hx, f.hy, f.hr, 1); }, i * 26);
    });
    topZ = S.length + 1;
  });

  // Grid view with a FLIP transition
  var toggle = host.querySelector('[data-mood-toggle]');
  function toggleGrid() {
    if (!grid) {
      cancelAnimationFrame(raf); raf = 0; if (drag) endDrag(true);
      var first = S.map(function (f) { f.px = f.mode === 'rest' ? f.x : f.tx; f.py = f.mode === 'rest' ? f.y : f.ty; f.pr = f.baseR; return f.el.getBoundingClientRect(); });
      var firstR = S.map(function (f) { return { r: f.r, s: f.s, w:f.w }; });
      grid = true; canvas.classList.add('is-grid');
      S.forEach(function (f) { f.mode = 'rest'; f.el.style.transition = 'none'; f.el.style.transform = 'none'; });
      var lastR = S.map(function (f) { return f.el.getBoundingClientRect(); });
      S.forEach(function (f, i) {
        var a = first[i], b = lastR[i];
        var dx = (a.left + a.width / 2) - (b.left + b.width / 2), dy = (a.top + a.height / 2) - (b.top + b.height / 2);
        f.el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(' + firstR[i].r + 'deg) scale(' + (firstR[i].s * firstR[i].w / f.el.offsetWidth) + ')';
      });
      void canvas.offsetWidth;
      S.forEach(function (f, i) {
        f.el.style.transition = reduce ? 'none' : 'transform .9s cubic-bezier(.16,1,.3,1) ' + (i * 16) + 'ms';
        f.el.style.transform = 'none';
      });
      toggle.textContent = toggle.dataset.board; toggle.setAttribute('aria-pressed', 'true');
    } else {
      var gr = S.map(function (f) { return f.el.getBoundingClientRect(); });
      canvas.classList.remove('is-grid'); grid = false;
      S.forEach(function (f) { f.el.style.transition = ''; });
      measure(); layout();
      var rc = canvas.getBoundingClientRect();
      S.forEach(function (f, i) {
        var g = gr[i];
        f.x = g.left + g.width / 2 - rc.left; f.y = g.top + g.height / 2 - rc.top; f.r = 0; f.s = 1;
        f.vx = f.vy = f.vr = f.vs = 0; render(f);
        var b = bounds(f);
        sendTo(f, clamp(f.px, b.minX, b.maxX), clamp(f.py, b.minY, b.maxY), f.pr, 1);
      });
      toggle.textContent = toggle.dataset.grid; toggle.setAttribute('aria-pressed', 'false');
    }
  }
  on(toggle, 'click', toggleGrid);


 const lb=host.querySelector('[data-mood-dialog]'),lbMedia=host.querySelector('[data-mood-lightbox-media]'),lbCap=host.querySelector('[data-mood-caption]');
 let lastFocus=null,paused=false,manual=false,inView=false,loaded=false;
 const motionButton=host.querySelector('[data-mood-motion]');
 const mediaNodes=()=>[...host.querySelectorAll('[data-mood-src]')];
 function freezeGif(img){
  if(!img.complete||!img.naturalWidth)return;
  try{const c=document.createElement('canvas');c.width=img.naturalWidth;c.height=img.naturalHeight;c.getContext('2d').drawImage(img,0,0);img.dataset.still=c.toDataURL('image/png');if(reduce||paused||!inView)img.src=img.dataset.still;}catch{if(reduce||paused||!inView)img.removeAttribute('src');}
 }
 function syncMedia(){
  const active=inView&&!document.hidden&&!paused&&(!reduce||manual)&&!lb.open;
  for(const el of canvas.querySelectorAll('[data-mood-src]')){
   if(el.tagName==='VIDEO'){if(active){if(!el.src)el.src=el.dataset.moodSrc;el.play().catch(()=>{});}else el.pause();}
   else if(el.hasAttribute('data-mood-gif')){if(active){if(el.src!==el.dataset.moodSrc)el.src=el.dataset.moodSrc;}else if(el.dataset.still)el.src=el.dataset.still;}
  }
  if(motionButton){motionButton.textContent=active?motionButton.dataset.pause:motionButton.dataset.play;motionButton.setAttribute('aria-pressed',String(active));}
 }
 function loadMedia(){if(loaded)return;loaded=true;for(const el of mediaNodes()){
  if(el.tagName==='VIDEO'){el.poster=el.dataset.moodPoster;}
  else{if(el.hasAttribute('data-mood-gif')){el.crossOrigin='anonymous';on(el,'load',()=>{if(!el.dataset.still)freezeGif(el);});}el.src=el.dataset.moodSrc;}
 }syncMedia();}
 const near=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){loadMedia();near.disconnect();}},{rootMargin:'500px'});near.observe(host);observers.push(near);
 const mediaView=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;syncMedia();});mediaView.observe(canvas);observers.push(mediaView);
 if(motionButton)on(motionButton,'click',()=>{if(reduce&&!manual){manual=true;paused=false;}else paused=!paused;syncMedia();});
 function openLightbox(f){
  if(lb.open)return;loadMedia();lastFocus=f.el;
  const w=parseFloat(getComputedStyle(f.el).getPropertyValue('--w')),h=parseFloat(getComputedStyle(f.el).getPropertyValue('--h'));
  const k=Math.min(innerWidth*.84/w,innerHeight*.68/h,2.4);
  lbMedia.replaceChildren();lbMedia.className='av-mood-lightbox-media '+f.el.className.replace('av-mood-fragment','').replace('lifted','');
  lbMedia.style.setProperty('--k',k);lbMedia.style.width=w*k+'px';lbMedia.style.height=h*k+'px';
  lbMedia.append(f.el.querySelector('.shape').cloneNode(true));
  for(const img of lbMedia.querySelectorAll('img[data-full-src]'))if(!img.hasAttribute('data-mood-gif'))img.src=img.dataset.fullSrc;
  lbCap.textContent=f.el.getAttribute('aria-label');lb.showModal();syncMedia();
  for(const video of lbMedia.querySelectorAll('video')){video.src=video.dataset.moodSrc;video.controls=true;if(!reduce)video.play().catch(()=>{});}
  lb.querySelector('[data-mood-close]').focus({preventScroll:true});
 }
 function closeLightbox(){if(lb.open)lb.close();}
 on(lb.querySelector('[data-mood-close]'),'click',closeLightbox);
 on(lb,'click',e=>{if(e.target===lb)closeLightbox();});
 on(lb,'close',()=>{lbMedia.querySelectorAll('video').forEach(v=>v.pause());lbMedia.replaceChildren();lastFocus?.focus({preventScroll:true});syncMedia();});
 on(preference,'change',()=>{reduce=preference.matches||document.querySelector('.av-header')?.dataset.avMotion==='false';if(reduce){if(drag)endDrag(true);S.forEach(f=>{f.vx=f.vy=f.vr=f.vs=0;sendTo(f,f.mode==='rest'?f.x:f.tx,f.mode==='rest'?f.y:f.ty,f.baseR,1);});}manual=false;syncMedia();});
 on(document,'visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;if(drag)endDrag(true);if(touch)clearTimeout(touch.timer);touch=null;}else kick();syncMedia();});
 on(window,'pagehide',()=>{host.querySelectorAll('video').forEach(v=>v.pause());});
 on(window,'pageshow',()=>syncMedia());
 document.fonts.ready.then(init);
 return ()=>{abort.abort();observers.forEach(o=>o.disconnect());timers.forEach(clearTimeout);cancelAnimationFrame(raf);host.querySelectorAll('video').forEach(v=>v.pause());if(lb.open)lb.close();};
 }
}
if(!customElements.get('ayume-moodboard'))customElements.define('ayume-moodboard',AyumeMoodboard);
